import React from "react";
import "../App.scss";
import ServiceConatiner from "./ServiceContainer/ServiceConatiner";
import Circle from "../img/circle.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Services() {
  return (
    <div className="servicescomp">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="about-text text-left">
              <h4 className="services-spantext">Services</h4>
              <img
                className="about-image"
                src={Circle}
                alt="images"
                className="circle1"
              />
              <h1 className="title-font">
                Designed for today, <br /> and built for Tomorrow
              </h1>
              <Link to="/Services">
                <button className="btn bodybutton">
                  Explore Services &nbsp; &nbsp;
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="bodybutton-icon"
                  />
                </button>
              </Link>
            </div>
            <ServiceConatiner />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
